import SubpageName from "src/model/SubpageName";
import { ROUTE_PATHS } from "src/config/routePaths";

export interface Route {
    title: string,
    href: string,
    name?: SubpageName,
    routes?: Route[],
    separator?: boolean
}

export const routes: Route[] = [
    {
        title: 'Home',
        href: '/',
        name: SubpageName.Home,
    },
    {
        title: 'Banner Config',
        href: '/banner-conf',
        name : SubpageName.PageConfig,
    },
    {
        title: 'Future Fee Config',
        href:'/futurefee',
        name: SubpageName.PageConfig,
    },
    {
        title: 'Fee Explainer Workflow',
        href: ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW,
        name: SubpageName.FeeExplainerPortal,
        routes: [
            {
                title: 'Rate String Logic Workflow',
                href: `${ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW}/rate-string-logic-workflow`,
            },
            {
                title: 'Feature Expression Workflow',
                href: `${ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW}/fe-workflow`,
            },
            {
                title: 'Decision Table Config',
                href: `${ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW}/decision-table-config`,
            },
            {
                title: 'Datakey Metadata',
                href: `${ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW}/datakey-metadata`,
            },
            {
                title: 'Fee Type Examples',
                href: `${ROUTE_PATHS.FEE_EXPLAINER_WORKFLOW}/fee-type-example`,
            }
        ]
    },
]
